module.exports = __webpack_public_path__ + "img/physio.6220b980.jpg";